import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import { PaymentSetting, ListPaymentSettingResponse} from "../http/protocol";


export class PaymentSettingService extends AbstractAdminEntityService<PaymentSetting, ListPaymentSettingResponse> {

    constructor(http : HttpService) {
        super("/payment-settings", http)
    }

}